import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Title from 'components/Title';
import FormGroup from 'components/form/Group';
import { VerticalLayout, GridLayout } from 'components/form/layout';
import { DateField, YesNoField, IntegerField } from 'components/form/field';
import { getSimulationTunnel } from 'utils/simulationTunnel';
import SCPICollection from './SCPICollection';
import Investment from './Investment';

const validateDuration = (value) => {
    if (!value || value < 10) {
        return 'Une durée minimum de 10 ans est requise';
    }

    if (value > 60) {
        return 'La durée maximum est de 60 ans';
    }

    return undefined;
};

const Operation = ({ showNeedFunding = true, namePrefix = 'data', needFunding, disabledButtonNeedFunding = false }) => {
    const simulationTunnel = getSimulationTunnel();
    const isScpiRendement = simulationTunnel && 'SCPIRendement' === simulationTunnel.recommendationType;
    const isScpiCredit = simulationTunnel && 'SCPIaCredit' === simulationTunnel.recommendationType;

    let forcedNeedFunding = needFunding;

    if (isScpiRendement) {
        forcedNeedFunding = false;
    } else if (isScpiCredit) {
        forcedNeedFunding = true;
    }

    const isNeedFundingDisabled =
        disabledButtonNeedFunding ||
        isScpiRendement ||
        isScpiCredit;

    return (
        <Fragment>
            <FormGroup>
                <Title><b>L&apos;opération</b></Title>
                <GridLayout className="condensed">
                    <DateField
                        name={`${namePrefix}.subscriptionDate`}
                        title="Date de souscription"
                        required
                    />
                    <IntegerField
                        name={`${namePrefix}.duration`}
                        title="Durée de l'investissement"
                        validate={validateDuration}
                        required
                    />
                </GridLayout>
            </FormGroup>
            <SCPICollection namePrefix={namePrefix} required />
            <VerticalLayout>
                <Investment namePrefix={namePrefix} />
                {showNeedFunding && (
                    <YesNoField
                        name={`${namePrefix}.needFunding`}
                        title="Avez-vous besoin d&apos;ajouter un financement ?"
                        required
                        needFunding={forcedNeedFunding}
                        disabled={isNeedFundingDisabled}
                    />
                )}
            </VerticalLayout>
        </Fragment>
    );
};

Operation.propTypes = {
    showNeedFunding: PropTypes.bool,
    namePrefix: PropTypes.string,
    needFunding: PropTypes.bool,
    disabledButtonNeedFunding: PropTypes.bool,

};
Operation.defaultProps = {
    needFunding: true,
};

export default Operation;
